import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/website/qrcode.png'


const _hoisted_1 = { class: "footerBox" }
const _hoisted_2 = { class: "footerBody" }
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = {
  key: 0,
  class: "links"
}
const _hoisted_5 = { class: "info" }

import { ref, onMounted, watch, reactive } from "vue";

import { getParameter } from "@/api/index";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const props = __props;

const mb: any = ref("");
const datas: any = reactive({
  record: "",
  ip: "",
});

watch(
  () => props.isMobile,
  (newv, oldv) => {
    props.isMobile ? (mb.value = true) : (mb.value = false);
  }
);
const getRecord = () => {
  getParameter("Record").then((res: any) => {
    datas.record = res.data;
  });
  getParameter("RecordIcp").then((res: any) => {
    datas.ip = res.data;
  });
};

const linkTo = (val: any) => {
  window.open(val, "_blank");
};

onMounted(() => {
  mb.value = props.isMobile;
  getRecord();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["footerBox clearfix", mb.value ? 'Mobile' : 'pc'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!mb.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _cache[19] || (_cache[19] = _createElementVNode("h1", null, "解决方案", -1)),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/website/solution')))
                    }, "通用解决方案"),
                    _createElementVNode("li", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/website/solution')))
                    }, "热门解决方案"),
                    _createElementVNode("li", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/website/solution')))
                    }, "智慧+商务"),
                    _createElementVNode("li", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/website/solution')))
                    }, "智慧+医疗"),
                    _createElementVNode("li", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/website/solution')))
                    }, "智慧+教育")
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("h1", null, "产品中心", -1)),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/website/product')))
                    }, "智慧教育"),
                    _createElementVNode("li", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/website/product')))
                    }, "智慧医疗"),
                    _createElementVNode("li", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/website/product')))
                    }, "智慧政企")
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("h1", null, "服务支持", -1)),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/website/support')))
                    }, "现场活动"),
                    _createElementVNode("li", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/website/support')))
                    }, "软件下载"),
                    _createElementVNode("li", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push('/website/support')))
                    }, "新品发布")
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[22] || (_cache[22] = _createElementVNode("h1", null, "新闻中心", -1)),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push('/website/news')))
                    }, "企业新闻"),
                    _createElementVNode("li", {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push('/website/news')))
                    }, "行业动态"),
                    _createElementVNode("li", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push('/website/news')))
                    }, "相关活动")
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[23] || (_cache[23] = _createElementVNode("h1", null, "关于晋才", -1)),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", {
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$router.push('/website/aboutUs')))
                    }, "企业简介"),
                    _createElementVNode("li", {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$router.push('/website/aboutUs')))
                    }, "荣誉资质"),
                    _createElementVNode("li", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$router.push('/website/recruitment')))
                    }, "人才招聘")
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "qrcode" }, [
            _createElementVNode("h1", null, "023-65402980"),
            _createElementVNode("div", { class: "item" }, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                }),
                _createElementVNode("br"),
                _createTextVNode(" 关注公众号 ")
              ])
            ])
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[25] || (_cache[25] = _createElementVNode("div", null, "重庆晋才富熙科技有限公司© Copyright 2008～2020 版权所有", -1)),
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (linkTo(datas.record.value)))
            }, _toDisplayString(datas.record.remark), 1),
            _createElementVNode("span", {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (linkTo(datas.ip.value)))
            }, _toDisplayString(datas.ip.remark), 1)
          ])
        ])
      ])
    ])
  ], 2))
}
}

})